import { render, staticRenderFns } from "./dictionaryManage.vue?vue&type=template&id=50dcc87c&scoped=true&"
import script from "./dictionaryManage.vue?vue&type=script&lang=js&"
export * from "./dictionaryManage.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryManage.vue?vue&type=style&index=0&id=50dcc87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcc87c",
  null
  
)

export default component.exports